import { generateUploaderEventHook } from "@rpldy/shared-ui";
import { TUS_EVENTS } from "@rpldy/tus-sender";
const useTusResumeStartListener = generateUploaderEventHook(TUS_EVENTS.RESUME_START);
export default useTusResumeStartListener;